import { ENVIRONMENT_FILE } from "@/globals";
import { Environment, useHelper } from "@react-three/drei";
import { AmbientLight } from "three";
import { PointLightHelper } from "three";
import { useRef } from "react";

export default function Lights() {
	const lightColor = "#fef1c9";
	const ambientIntensity = 0;
	const environmentIntensity = 0.8;

	// Create references for the point lights
	const pointLightRef = useRef<THREE.PointLight>(null);
	useHelper(pointLightRef, PointLightHelper, 0.1, "red"); // 0.1 = size of the helper

	return (
		<>
			<pointLight position={[0.3, 1, -0.2]} intensity={1} color={"#fff"} distance={1} />
			{/* <pointLight position={[-0.3, 0.2, -0.25]} intensity={.02} color={"#fff"} distance={1} /> */}
			<ambientLight color={lightColor} intensity={ambientIntensity} />
		</>
	);
}
